import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import './responsive.css';
import './auth.css';
import './admin-mobile.css';
import { initSidebarState } from './utils/sidebarState';
import { initPwaInstall } from './utils/pwaInstall';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./Redux/store"

initSidebarState();
initPwaInstall();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
       <App />
    </Provider>
  
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
